<template>
  <div id="videos" class="page">
    <section class="page-title">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <ol class="breadcrumb">
              <li>
                <router-link to="/">Accueil</router-link>
              </li>
              <li>Videos</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
    <section class="faq-pg-section section-padding-50">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="section-title-s4">
              <h1>Videos <div>des garde-corps OXYNOV</div></h1>
              <blockquote>
                Découvrez l'ensemble de la gamme de garde-corps OXYNOV en vidéos, exemples de pose, installation des poteaux, pose du remplissage, finitions... Apprenez à installer un garde-corps Oxynov comme un véritable professionnel de l'aménagement. Retrouvez-nous sur notre <a href="https://www.youtube.com/user/Oxynov" target="_blank">chaîne Youtube</a>.
              </blockquote>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10">
            <div id="video" class="detail">
              <h2>
                {{ selectedVideo.title }}
              </h2>
              <div class="embed-responsive embed-responsive-16by9">
                <iframe class="embed-responsive-item" :src="'https://www.youtube.com/embed/' + selectedVideo.id + '?wmode=opaque&rel=1'"></iframe>
              </div>
              <p>
                {{ selectedVideo.description }}
              </p>
            </div>
          </div>
          <div class="col-md-2" style="border-left: dashed 1px #DDD">
            <div id="videos-container">
              <ul v-for="(g, i) in videos" v-bind:key="i" class="videos-list">
              <li class="title">
                <h2>{{ i }}</h2>
              </li>
              <li v-for="(v, k) in g" v-bind:key="k">
                <a href="#" rel="nofollow" id="'video-' + k" class="" :title="v.title" @click="selectVideo(v)">
                  <img :src="'https://img.youtube.com/vi/' + v.id + '/2.jpg'" :alt="v.title" class="img-responsive">
                  {{ v.title }}
                </a>
              </li>
            </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Videos',
  data () {
    return {
      videos: {
        'Logiciel de Devis 3D OXYNOV': [
          { title: 'Logiciel de devis Oxynov 3d', id: 'xyDcPmiyhYM', description: 'Le devis 3D généré par notre calculateur vous donne précisément les cotes, la liste du matériel, ainsi que les emplacements exacts de positionnement des poteaux. Il vous suffira alors de suivre les étapes de montage pour installer votre garde-corps.' }
        ],
        'Installation des poteaux': [
          { title: 'Installation d\'un poteau à plat (à la française)', id: 'QoROYf0FQ34', description: 'Détail de la fixation d\'un poteau inox OXYNOV pré-équipé en usine de 5 supports de barre, de tête amovible de rampe et d\'un cache support. La fixation d\'un poteau à la française (fixation à plat) s\'effectue à l\'aide de 4 tire-fonds (dans le bois) ou de chevilles (dans le béton).' },
          { title: 'Installation d\'un poteau latéral (à l\'anglaise)', id: 'Ba0tP-Mkhyg', description: 'Les poteaux inox (304 ou 316) des garde-corps OXYNOV se déclinent en 2 types : fixation à la française (à plat) ou fixation latérale (à l\'anglaise). Les poteaux fixés en latéral sont pré-équipés en usine. Ils possèdent 5 supports de barre, ainsi qu\'un support de rampe amovible. La fixation des poteaux s\'effectue à l\'aide de tire-fonds inox (bois) ou de chevilles inox (béton).' }
        ],
        'Assemblage de main courante INOX': [
          { title: 'Assemblage d\'une main courante - Rampe INOX', id: 'pXtGI4vvyZA', description: 'Assemblage et fixation d\'une rampe inox d\'un garde-corps OXYNOV. Explications et détails des mises à longueurs et des coupes. Raccordement entre plusieus rampes et fixation de coudes amovibles. Fixation des rampes sur les têtes de poteaux inox.' },
          { title: 'Raccordement d\'une main courante - Rampe inox avec manchon de liaison', id: 'sh-Pq0f048c', description: 'Détails et explications de l\'assemblage de deux rampes en inox OXYNOV. Le raccordement s\'effectue très facilement à l\'aide d\'un manchon et d\'un tube de colle LOCTITE.' }
        ],
        'Assemblage de main courante BOIS': [
          { title: 'Assemblage d\'une main courante - Rampe BOIS', id: '4FV5wy0gRlU', description: 'Assemblage d\'une rampe en bois exotique (méranti) d\'un garde-corps en inox OXYNOV. Explication des coupes des raccordements et des traitements des angles. Fixation de la rampe en bois de la balustrade sur les têtes de poteaux inox.' },
          { title: 'Raccordement d\'une main courante - Rampe bois avec manchon et coude', id: 'yGYz1cf7AhM', description: 'Les rampes en bois exotique des garde-corps OXYNOV se raccordent très simplement entre-elles à l\'aide des inserts de liaison en plastique et du gabarit de perçage pour les fixer.' }
        ],
        'Remplissage de garde-corps par tubes inox': [
          { title: 'Remplissage de garde-corps par tubes inox', id: 'dGKR_eENsjA', description: 'Détails du montage d\'une série de 5 tubes de remplissage en inox de D = 12 mm d\'un garde-corps en inox OXYNOV. Traitement de l\'installation des barres inox sur un rampant d\'escalier et fixation des barres sur le mur de départ. Les barres s\'installent très facilement par collage.' },
          { title: 'Remplissage de garde-corps - le raccordement des tubes inox', id: 'b_YM-aawjVE', description: 'Explication détaillée du raccordement des tubes de remplissage de garde-corps inox OXYNOV dans le cas d\'un angle à 90° et du raccordement des barres entre elles.' },
          { title: 'Pose d\'un panneau sécuritaire transparent (norme NFP 01-012)', id: 'Qc2A34IMVX8', description: 'Pose d\'un panneau sécuritaire transparent (norme NFP 01-012)</a><p>La gamme de garde-corps OXYNOV propose la pose d\'un panneau en verre méthacrylate pour être conforme à la norme NFP 01-012. La pose de ce panneau ne peut s\'effectuer que sur des tubes inox de diamètre 12mm.' }
        ],
        'Remplissage de garde-corps par câbles': [
          { title: 'Remplissage de garde-corps par câbles et tendeurs', id: 'p7ssHb_wTwc', description: 'Détails de l\'installation d\'une série de 5 câbles inox sur les poteaux d\'un garde-corps OXYNOV. Fixation des câbles sur le mur de départ et traitement des angles de la balustrade inox. Arrêt des câbles sur un poteau.' }
        ],
        'Nettoyage et entretien de l\'inox': [
          { title: 'Nettoyage et entretien de l\'inox 304 ou 316', id: 'IciRSZub8mU', description: 'Le garde-corps inox OXYNOV, comme toutes les rambardes exige un minimum d\'entretien. OXYNOV recommande l\'emploi des produits INNOSOFT et INNOPROTECT pour faire disparaitre les traces de rouille éventuelles et protéger l\'inox durablement dans les environnement très agressifs.' }
        ],
        'Exemples de montage': [
          { title: 'Garde-corps avec angle de 90° et câbles inox - poteau unique', id: 'r_RHRnDYRgE', description: 'Montage d\'un garde-corps inox OXYNOV avec des poteaux à plat fixés sur un plancher en bois et des câbles en inox. L\'angle de la balustrade est réalisé, dans ce cas, à l\'aide d\'un seul poteau. Une pièce spéciale est utilisée sous le coude de la rampe en remplacement du support de rampe standard livré avec le poteau.' },
          { title: 'Garde-corps avec angle de 90° et câbles inox - 2 poteaux', id: '8WWhHJ2cDfE', description: 'Pose d\'un garde-corps inox OXYNOV dans le cas de poteaux fixés à la française (à plat) avec des câbles en inox 316. Cas de figure où l\'angle est réalisé à l\'aide de 2 poteaux.' },
          { title: 'Installation de garde-corps Oxynov à poteau latéral + rampe bois + câbles inox', id: 'rWJHqBBbTBk', description: 'Exemple d\'installation d\'un garde-corps inox OXYNOV dans le cas d\'un poteau fixé à l\'anglaise (latéral) avec une rampe en bois en méranti et de câbles en inox. Ce cas détaille le montage d\'un garde-corps avec un escalier et un angle à 90°. Les raccords de rampe bois et des câbles inox.' },
          { title: 'Installation de garde-corps Oxynov poteau à plat + rampe et tubes inox', id: 'ToeOhQflHSU', description: 'Exemple d\'installation d\'un garde-corps en inox OXYNOV dans le cas de figure d\'un poteau fixé à la française (à plat), d\'une rampe en inox et d\'un remplissage à l\'aide d\'une rangée de 5 tubes inox de diamètre 12mm. Les poteaux sont pré-équipés en usine, l\'assemblage des tubes et des rampes s\'effectue très simplement par vissage et par collage.' },
          { title: 'Installation de garde-corps Oxynov poteau à plat avec rampe et tube inox', id: 'FDqodcrTTeU', description: 'Le garde-corps Oxynov est un concept de balustrade en inox prêt-à-poser. L\'installation est très simple, elle s\'effectue avec une visseuse et un tube de colle ! Oxynov est proposé en 2 qualités d\'inox : 304 (standard) et 316 (pour les milieux agressifs : air salin...).' }
        ]
      },
      selectedVideo: {}
    }
  },
  methods: {
    selectVideo (v) {
      this.selectedVideo = v
    }
  },
  mounted () {
    this.selectedVideo = this.videos['Logiciel de Devis 3D OXYNOV'][0]
  }
}
</script>

<style type="text/css" scoped>
#video.detail h2 {
  font-size: 20px;
  margin-bottom: 20px;
}
#video.detail p {
  margin-top: 20px;
}
#videos-container {
  max-height: 645px;
  overflow-y: scroll;
}
.videos-list {
  list-style: none;
  margin-bottom: 0;
}
.videos-list li {
  border-bottom: dotted 1px #6A8590;
  padding: 10px 0;
}
.videos-list > li:first-child {
  border: 0;
  padding-top: 0;
}
.videos-list > li:first-child h2 {
  margin-top: 0;
}
.videos-list li img {
  width: 100%;
}
.videos-list .title h2 {
  font-size: 13px;
  color: #025d90;
  margin-bottom: 0;
  margin-top: 10px;
}
.videos-list img {
  margin-bottom: 10px;
}
.videos-list a {
  font-size: 12px;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Videos.vue